import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { environment } from '../../../environments/environment';


@Component( {
  selector: 'rip-rss-app-wall',
  template: `
    <div #containerDiv
         style="max-height: 100%;">
      <rssapp-wall id="{{rssAppId}}"></rssapp-wall>
    </div>
  `,

} )

export class RssAppWallComponent implements AfterViewInit {

  @ViewChild( 'containerDiv', { static: false } ) containerDiv: ElementRef;

  rssAppId: string = environment.common.rssAppId;

  ngAfterViewInit(): void {
    setTimeout( () => {
      const script = document.createElement( 'script' );
      script.src = 'https://widget.rss.app/v1/wall.js';
      script.async = true;
      this.containerDiv.nativeElement.appendChild( script );
    } );
  }

}
